import { Container, SvgIcon } from "@mui/material";
import React from "react";

import PlayCircleIcon from "@heroicons/react/24/outline/CurrencyEuroIcon";

const TableSellAction = () => {
  return (
    <SvgIcon
      color="primary"
      sx={{
        width: "1.35rem",
      }}
    >
      <PlayCircleIcon />
    </SvgIcon>
  );
};

export default TableSellAction;
